import { Component, input, output } from '@angular/core';

import { InvalidEnabledField } from 'src/app/utils/form-validation.helper';

import { InvalidFieldBadgesComponent } from '../invalid-field-badges/invalid-field-badges.component';

@Component({
  selector: 'app-invalid-form-summary',
  templateUrl: './invalid-form-summary.component.html',
  styleUrls: ['./invalid-form-summary.component.scss'],
  imports: [InvalidFieldBadgesComponent]
})
export class InvalidFormSummaryComponent {
  readonly errorText = input<string>('');
  readonly invalidFields = input<InvalidEnabledField[]>([]);
  readonly fieldSelected = output<string>();

  onFieldSelected(fieldName: string): void {
    this.fieldSelected.emit(fieldName);
  }
}
